import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  isLoadPacks: false,
  isLoadRestau5: false,
  errorRestau5: "",
  packs: [],
  modules: [],
  packsSearchResult: null,
  conversationsRestau: null,
};

const getters = {
  isLoadPacks: state => state.isLoadPacks,
  isLoadRestau5: state => state.isLoadRestau5,
  errorRestau5: state => state.errorRestau5,
  packs: state => state.packs,
  modules: state => state.modules,
};

const mutations = {
  getPacksSuccess(state, payload) {
    state.isLoadPacks = true;
    state.packs = payload.packs;
  },
  getModulesSuccess(state, payload) {
    state.isLoadPacks = true;
    state.modules = payload.modules;
  },
  addPackSuccess(state, payload) {
    state.isLoadPacks = true;
    let packs = state.packs;
    packs.push(payload.data);
    state.packs = packs;
  },
  editPackSuccess(state, payload) {
    state.isLoadPacks = true;
    let packs = state.packs;

    let newPacks = [];
    packs.map((pack, index) => {
      if (pack._id == payload.data._id) {
        newPacks.push({ ...payload.data });
      } else {
        newPacks.push({ ...pack });
      }
    });

    state.packs = [...newPacks];
  },
  deletePackSuccess(state, payload) {
    state.isLoadPacks = true;
    let packs = state.packs;

    let newPacks = [];
    packs.map((pack, index) => {
      if (pack._id != payload.data._id) {
        newPacks.push({ ...pack });
      }
    });
    state.packs = [...newPacks];
  },
  addClientTTSuccess(state, payload) {
    state.isLoadPacks = true;

  },
  getPacksError(state, error) {
    state.isLoadPacks = false;
    state.errorRestau5 = error;
  },

  addPackError(state, error) {
    state.isLoadPacks = false;
    state.errorRestau5 = error;
  }
};

const actions = {
  getPacks({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    axios
      .get(`${apiPath}/packs`, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getPacksSuccess", {
            packs: res.data
          });
        } else {
          commit("getPacksError", "error:getPacks");
        }
      });
  },
  getModules({ commit }, payload) {
    token = localStorage.getItem("accessToken");
    config = {
      headers: {
        Authorization: "Bearer " + token
      }
    };
    axios
      .get(`${apiPath}/modules`, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getModulesSuccess", {
            modules: res.data
          });
        } else {
          commit("getPacksError", "error:getPacks");
        }
      });
  },
  addPack({ commit }, payload) {
    return axios
      .post(`${apiPath}/packs`, payload, config)
      .then(r => r)
      .catch(r => r);
    // if (res.ok) {
    //     commit("addPackSuccess", res);
    //   } else {
    //     commit("addPackError", "error:addPack");
    //   }
  },
  editPack({ commit }, payload) {
    return axios
      .post(`${apiPath}/packs/${payload._id}`, payload, config)
      .then(r => r)
      .catch(r => r);
  },
  deletePack({ commit }, payload, config) {
    return axios
      .delete(`${apiPath}/packs/${payload._id}`, config)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deletePackSuccess", payload);
        // } else {
        //   commit("addPackError", "error:addPack");
        // }
        return payload;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
